import classNames from 'classnames'
import i18n from 'i18next'

import { SVGImageCurrentColor } from 'utils/svgHelper'
import toolbarSecureSend from 'assets/images/toolbar-secure-send.svg'

import styles from './style.module.scss'

interface ConfidentialBannerProps {
  secureSendExpired: string | null
  onRemoveAccess: () => void
}

const ConfidentialBanner = ({ secureSendExpired, onRemoveAccess }: ConfidentialBannerProps) => {
  const formattedDate = secureSendExpired
    ? new Date(secureSendExpired).toLocaleDateString(i18n.language || 'en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    : ''

  return (
    <div className={classNames(styles.secureBanner)}>
      <div
        className={classNames(styles.secureBannerIcon)}
        style={{ color: '#FD4C45', width: 20, height: 20 }}
      >
        <SVGImageCurrentColor src={toolbarSecureSend} alt="secure send" />
      </div>
      <div className={classNames(styles.secureBannerMessages)}>
        <span className={classNames(styles.secureBannerTitle)}>
          {i18n.t('secureSend.expiresOn', { date: formattedDate })}
        </span>
        <span className={classNames(styles.secureBannerDesc)}>
          {i18n.t('secureSend.confidentialMessage')}
        </span>
      </div>
      <div className={classNames(styles.secureBannerButtons)}>
        <button type="button" onClick={onRemoveAccess}>
          {i18n.t('secureSend.removeAccess')}
        </button>
      </div>
    </div>
  )
}

export default ConfidentialBanner
